module.exports = __webpack_public_path__ + "static/front-page-10-c955263748aeee97a98a7e8fe1740758.jpg";